<template>
  <div class="practice-card--wrap">
    <div class="practice-card">
      <div class="practice-card__avatar--wrap">
        <lazy-image
          :src="user.thumbnailUrl"
          :fallback="require('@/assets/loggedPlaceholder96x96.png')"
          :alt="user.name"
          wrapperClass="practice-card__avatar--wrap"
          imgClass="practice-card__avatar"
        />
        <v-file-input
          v-if="allowedToChangePracticeImage"
          hide-input
          hide-details
          :accept="getMimeTypes(18)"
          class="practice-card__avatar-change-button"
          prepend-icon="bhi-image"
          truncate-length="15"
          @change="selectAvatar"
        ></v-file-input>
      </div>
      <div class="practice-card__name--wrap">
        <p class="practice-card__name" v-if="user.name">
          <span>{{
            user.name.length > 10
              ? user.name.substring(0, 10) + '...'
              : user.name
          }}</span>
        </p>
        <span class="practice-card__status">
          <i class="bh-dot bhYellowDark">&nbsp;</i>
          {{ user.isActive ? 'Active' : 'Inactive' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { FILE_SIZE_LIMIT, FILE_SIZE_LIMIT_NAME } from '@/helpers/constants'
import LazyImage from '../lazy/LazyImage.vue'

export default {
  components: { LazyImage },
  name: 'PracticeCard',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    getMimeTypes: {
      type: Function,
      default: () => null,
    },
  },
  data: () => ({}),
  computed: {
    allowedToChangePracticeImage() {
      const allowedRoles = ['Admin', 'Technical support', 'Administrator']
      if (allowedRoles.includes(this.$store.state.userStates.rolename))
        return true
      else return false
    },
  },
  methods: {
    ...mapMutations('appStates', ['setSnackbarNotification']),
    selectAvatar(file) {
      const data = { file }
      if (file.size <= FILE_SIZE_LIMIT) {
        this.$emit('updateAvatar', data)
      } else {
        this.setSnackbarNotification(
          `Max upload file size is ${FILE_SIZE_LIMIT_NAME}. Try again with smaller file.`,
        )
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables';

.practice-card {
  display: flex;

  &__avatar {
    border-radius: $border-radius-root2;

    &--wrap {
      display: flex;
      position: relative;
      margin-right: 16px;
      flex-shrink: 0;
      width: 80px;
      height: 80px;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    &-change-button {
      position: absolute;
      bottom: -8px;
      right: -8px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: $border-radius-root;
      background: $bh-white;
      padding: 0;
      margin: 0;
      color: $bh-blue;

      .v-icon {
        color: $bh-blue;
      }

      .v-input__prepend-outer {
        margin: 0;
      }
    }
  }

  &__name {
    font-size: 1.42857rem;
    line-height: 1;
    color: $bh-blue;
    font-weight: 700;

    &--wrap {
      padding-top: 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      height: 100%;
    }
  }

  &__status {
    font-size: 0.85715rem;
    line-height: 1.16666667em;

    .bh-dot {
      margin-right: 8px;
    }
  }

  &__last-login {
    display: inline-block;
    width: 100%;
    font-size: 0.85715rem;
    line-height: 1.16666667em;
    padding: 20px 0 0;
  }
}
</style>
